import React, { useState } from "react";
import "./CandidateFormModal.css";
import { extendSubscription } from "../../api/adminSubscriptionApi";

const ExtendSubscriptionModal = ({ subscription, onClose, onSuccess }) => {
  const [newEndDate, setNewEndDate] = useState("");

const handleExtend = async () => {
  if (!newEndDate) {
    alert("Please select a new end date");
    return;
  }

  try {
    await extendSubscription(subscription.id, {
      newEndDateCst: newEndDate
    });

    onSuccess();
    onClose();
  } catch (err) {
    console.error("Extend subscription failed:", err);

    // Backend validation message
    const message =
      err?.response?.data?.message ||
      "New end date must be after current end date";

    alert(message);
  }
};


  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>Extend Subscription</h2>

        <div className="form-group">
          <label>Role</label>
          <div>{subscription.role}</div>
        </div>

        <div className="form-group">
          <label>Applications / Day</label>
          <div>{subscription.applicationsPerDay}</div>
        </div>

        <div className="form-group">
          <label>Current End Date</label>
          <div>
            {new Date(subscription.endDateCst).toLocaleDateString()}
          </div>
        </div>

        <div className="form-group">
          <label>New End Date</label>
          <input
            type="datetime-local"
            value={newEndDate}
            onChange={e => setNewEndDate(e.target.value)}
          />
        </div>

        <div className="modal-actions">
          <button className="secondary" onClick={onClose}>Cancel</button>
          <button onClick={handleExtend}>Extend</button>
        </div>
      </div>
    </div>
  );
};
export default ExtendSubscriptionModal;